import {lazy} from '@aboutyou/lazy-imports';

export const SponsoredContentLane = lazy(() =>
  import('./SponsoredContentLane.eager').then(mod => ({
    default: mod.SponsoredContentLane,
  })),
);
